import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import { getDefaultKeys } from '@/utils/handleData'
const organization = {
  navBar: {
    navTitle: '机构列表',
    queryFun: 'organization/getOrganRelationsList'
  },
  orgRelations: {
    name: 'orgRelations',
    theme: '组织关系',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'dialogForm',
      'navBar'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'organization/getOrganRelationsList',
    deleteFun: 'organization/deleteOrganRelations',
    detailPage: [
      {
        buttonName: '添加上级',
        type: 'dialogForm',
        name: 'orgRelations'
      }
    ],
    headButtons: setCheckButtons(['添加上级']),
    tagInfo:
      '上下级关系可在此关联或解除，会同步更新工程、企业、标段基础信息中的管理字段。劳务公司请在参建单位-劳务公司中办理进场或删除。非超管员添加后不可删除上级组织，只可删除下级组织',
    rowButtons: setTableButtons(['删除']),
    rowData: (params) => {
      return params.state.organization.organRelations
    },
    columns: [
      { prop: 'startCode', label: '机构名称', minWidth: '220px' },
      {
        prop: 'relationType',
        label: '组织管理关系',
        minWidth: '140px',
        tag: [{ type: 'danger', label: '上级组织' }]
      },
      {
        prop: 'professionalType',
        label: '管理类型',
        minWidth: '120px',
        tag: [
          { type: 'danger', label: '直属工程' },
          { type: 'warning', label: '直属企业' }
        ]
      },
      {
        prop: 'professionalNature',
        label: '管理性质',
        minWidth: '120px',
        tag: [{ type: 'danger', label: '管控' }]
      },
      {
        label: '操作',
        buttons: setTableButtons(['删除']),
        minWidth: '100px'
      }
    ],
    orgRelations: {
      title: '添加组织关系',
      addFun: 'organization/addOrganRelations',
      addArray: true,
      getParentFun: 'organization/getOrganRelationsList',
      formParams: {
        startUid: [],
        endUid: (params) => {
          return params.activeNav
        },
        relationType: '上级组织',
        professionalType: '项目监管',
        professionalNature: '监管'
      },
      formRules: {
        startUid: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个选项',
            trigger: 'blur'
          }
        ],
        professionalType: [
          {
            required: true,
            message: '请选择管理类型',
            trigger: 'blur'
          }
        ],
        professionalNature: [
          {
            required: true,
            message: '请选择管理性质',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'professionalType',
          label: '管理类型',
          type: 'select',
          options: [
            { value: '1', label: '项目监管' },
            { value: '2', label: '企业监管' },
            { value: '3', label: '政府监管' },
            { value: '4', label: '直属企业' },
            { value: '5', label: '直属工程' }
          ]
        },
        {
          key: 'professionalNature',
          label: '管理性质',
          type: 'select',
          disabled: (params) => {
            return (
              params.formValues &&
              params.formValues.professionalType !== '企业监管'
            )
          },
          options: [
            { value: '1', label: '监管' },
            { value: '2', label: '管控' }
          ]
        },
        {
          key: 'startUid',
          label: '上级机构',
          type: 'select',
          placeholder: (params) => {
            const type =
              params.formValues && params.formValues.professionalType
            if (type === '企业监管' || type === '直属企业') {
              return '请输入关键词搜索企业'
            }
            if (type === '直属工程') {
              return '请选择上级工程'
            }
            return '请选择上级机构'
          },
          titles: ['可选机构', '已选机构'],
          multiple: true,
          filterable: true,
          clearable: true,
          remote: (params) => {
            const type =
              params.formValues && params.formValues.professionalType
            return type === '企业监管' || type === '直属企业'
          },
          options: (params) => {
            const type =
              params.formValues && params.formValues.professionalType
            const current = params.activeNav
            const notCurrent = (item) => {
              return (
                item &&
                item.value !== current &&
                item.vType !== 'laborCom' &&
                item.vtype !== 'laborCom'
              )
            }
            if (type === '企业监管' || type === '直属企业') {
              return params.state.enterprise.enterprises || []
            }
            const projects = Array.isArray(params.state.project.projectNames)
              ? params.state.project.projectNames
              : []
            if (type === '直属工程') {
              return projects.filter(notCurrent)
            }
            const bids = params.getters['bidSection/unconnectedBid'] || []
            return bids.concat(projects).filter(notCurrent)
          },
          checkByValue: true,
          span: 24
        }
      ]
    }
  },
  department: {
    name: 'department',
    theme: '职能部门',
    componentTypes: ['navigate', 'check', 'tables', 'dialogForm'],
    headButtons: setCheckButtons(['新增', '同步系统默认', '重置为系统默认']),
    detailPage: [
      {
        buttonName: '新增',
        type: 'dialogForm',
        name: 'department'
      },
      {
        buttonName: '编辑',
        type: 'dialogForm',
        name: 'department',
        checkType: 'useRowData'
      }
    ],
    getListFun: (params) => {
      return params.orgName !== '甘肃大鹏鸟科技有限公司'
        ? 'organization/getOrgDepartment'
        : 'dictionary/getDepartment'
    },
    deleteFun: (params) => {
      return params.orgName !== '甘肃大鹏鸟科技有限公司'
        ? 'organization/deleteOrgDepartment'
        : 'dictionary/deleteDepartment'
    },
    outListHeight: 240,
    rowData: (params) => {
      var departments = []
      if (
        params.orgName !== '甘肃大鹏鸟科技有限公司' &&
        params.orgFields.department
      ) {
        params.orgFields.department.forEach((item) => {
          if (item.children && item.children.length) {
            item.children.forEach((org) => {
              org.type = item.name
            })
          }
          getDefaultKeys(item, '', departments)
        })
      } else if (
        params.orgName === '甘肃大鹏鸟科技有限公司' &&
        params.dictionarys.department
      ) {
        departments = params.dictionarys.department
      }
      return departments
    },
    columns: [
      { prop: 'code', label: '机构编码', width: '' },
      { prop: 'name', label: '机构名称', width: '' },
      { prop: 'type', label: '机构类型', width: '' },
      { prop: 'mark', label: '机构描述', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    department: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增职能部门'
          : params.pageStatus === 'edit'
          ? '编辑职能部门'
          : '职能部门'
      },
      addFun: (params) => {
        return params.orgName === '甘肃大鹏鸟科技有限公司'
          ? 'dictionary/addDepartment'
          : 'organization/addOrgDepartment'
      },
      editFun: (params) => {
        return params.orgName === '甘肃大鹏鸟科技有限公司'
          ? 'dictionary/editDepartment'
          : 'organization/editOrgDepartment'
      },
      getParentFun: (params) => {
        return params.orgName === '甘肃大鹏鸟科技有限公司'
          ? 'dictionary/getDepartment'
          : 'organization/getOrgDepartment'
      },
      formParams: {
        projectUid: (params) => {
          return params.orgValue
        },
        uid: '',
        code: '',
        name: '',
        type: (params) => {
          return params.orgName === '甘肃大鹏鸟科技有限公司'
            ? ''
            : params.orgBuildType
            ? params.orgBuildType
            : '其他'
        },
        typeCode: (params) => {
          var typeCode = '099'
          if (params.orgBuildType === '建设单位') {
            typeCode = '001'
          } else if (params.orgBuildType === '总承包单位') {
            typeCode = '002'
          } else if (params.orgBuildType === '监理单位') {
            typeCode = '003'
          } else if (params.orgBuildType) {
            typeCode = '004'
          }
          return typeCode
        },
        mark: ''
      },
      formRules: {
        code: [
          {
            required: true,
            message: '请输入机构编码',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入机构名称',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择上级机构参建类型',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'code',
          label: '机构编码',
          type: 'input',
          span: 18,
          offset: 3
        },
        {
          key: 'name',
          label: '机构名称',
          type: 'input',
          span: 18,
          offset: 3
        },
        {
          key: 'type',
          label: '机构类型',
          type: 'select',
          disabled: (params) => {
            return params.orgName !== '甘肃大鹏鸟科技有限公司'
          },
          options: (params) => {
            var types = params.dictionarys.buildType
              ? JSON.parse(JSON.stringify(params.dictionarys.buildType))
              : []
            types.push({ value: '999', label: '其他' })
            return types
          },
          span: 18,
          offset: 3
        },
        {
          key: 'mark',
          label: '机构描述',
          type: 'input',
          span: 18,
          offset: 3
        }
      ]
    }
  },
  factory: {
    name: 'factory',
    theme: '场站工区',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'stepForm',
      'dialogForm',
      'drawerTable'
    ],
    checkType: 'useRowData',
    headButtons: setCheckButtons(['新增']),
    addFun: 'organization/addOrgFactory',
    editFun: 'organization/editOrgFactory',
    getListFun: 'organization/getOrgFactory',
    deleteFun: 'organization/deleteOrgFactory',
    getParentFun: 'organization/getOrgFactory',
    deleteConfirm: '删除场站工区将同时解除已关联的管理人员、机械设备和劳务公司，是否继续？',
    queryParams: {
      factoryType: '',
      keyword: ''
    },
    selectData: [
      {
        key: 'factoryType',
        label: '场站类型',
        type: 'select',
        clearable: true,
        placeholder: '请选择场站类型',
        options: [
          { label: '项目驻地', value: '项目驻地' },
          { label: '混拌站', value: '混拌站' },
          { label: '稳拌站', value: '稳拌站' },
          { label: '沥拌站', value: '沥拌站' },
          { label: '预制厂', value: '预制厂' },
          { label: '钢筋加工厂', value: '钢筋加工厂' },
          { label: '作业工区', value: '作业工区' }
        ]
      },
      {
        key: 'keyword',
        label: '关键词',
        type: 'input',
        clearable: true,
        placeholder: '场站名称/负责人姓名'
      }
    ],
    detailPage: [
      {
        buttonName: '新增',
        name: 'factory',
        type: 'stepForm',
        theme: 'organization',
        step: 'factoryInfo',
        label: '新增场站工区'
      },
      {
        buttonName: '编辑',
        name: 'factory',
        type: 'stepForm',
        theme: 'organization',
        step: 'factoryInfo',
        label: '编辑场站工区',
        checkType: 'useRowData'
      },
      {
        buttonName: '关联人员',
        type: 'dialogForm',
        name: 'factoryBindAdmin',
        checkType: 'checkByUid',
        checkFun: 'organization/getFactoryAdminBindForm',
        pageStatus: 'edit'
      },
      {
        buttonName: '关联机械',
        type: 'dialogForm',
        name: 'factoryBindCar',
        checkType: 'checkByUid',
        checkFun: 'organization/getFactoryCarBindForm',
        pageStatus: 'edit'
      },
      {
        buttonName: '关联劳务',
        type: 'dialogForm',
        name: 'factoryBindLabor',
        checkType: 'checkByUid',
        checkFun: 'organization/getFactoryLaborBindForm',
        pageStatus: 'edit'
      },
      {
        buttonName: '管理人员',
        type: 'drawerTable',
        name: 'factoryAdmins',
        checkType: 'checkByUid',
        checkFun: 'organization/getFactoryAdminList'
      },
      {
        buttonName: '机械设备',
        type: 'drawerTable',
        name: 'factoryCars',
        checkType: 'checkByUid',
        checkFun: 'organization/getFactoryCarList'
      },
      {
        buttonName: '劳务公司',
        type: 'drawerTable',
        name: 'factoryLabors',
        checkType: 'checkByUid',
        checkFun: 'organization/getFactoryLaborList'
      }
    ],
    rowData: (params) => {
      const list = (params.state.organization &&
        params.state.organization.orgFactory) ||
        []
      const query = params.queryValues || {}
      const factoryType = query.factoryType || ''
      const keyword = query.keyword
        ? String(query.keyword).trim().toLowerCase()
        : ''
      if (!factoryType && !keyword) return list
      return list.filter((item) => {
        if (factoryType && item.factoryType !== factoryType) return false
        if (keyword) {
          const name = String((item && item.name) || '').toLowerCase()
          const adminName = String((item && item.adminName) || '').toLowerCase()
          if (name.indexOf(keyword) < 0 && adminName.indexOf(keyword) < 0) {
            return false
          }
        }
        return true
      })
    },
    columns: [
      { prop: 'code', label: '场站/工区编码', width: '' },
      { prop: 'name', label: '场站/工区名称', width: '' },
      { prop: 'factoryType', label: '场站工区类型', width: '120px' },
      { prop: 'adminName', label: '负责人姓名', width: '' },
      { prop: 'adminPhone', label: '负责人电话', width: '' },
      { prop: 'adminCountText', label: '管理人员', width: '120px', drillDown: true },
      { prop: 'carCountText', label: '机械设备', width: '120px', drillDown: true },
      { prop: 'laborCountText', label: '劳务公司', width: '120px', drillDown: true },
      {
        prop: 'locationText',
        label: '地理位置',
        minWidth: '280px',
        overflow: false,
        overflowWidth: true,
        className: 'multi-line'
      },
      {
        label: '操作',
        buttons: setTableButtons([
          '编辑',
          '删除',
          {
            name: '关联人员',
            style: {
              border: '1px solid #67C23A',
              color: '#ffffff',
              background: '#67C23A'
            }
          },
          {
            name: '关联机械',
            style: {
              border: '1px solid #4089FF',
              color: '#ffffff',
              background: '#4089FF'
            }
          },
          {
            name: '关联劳务',
            style: {
              border: '1px solid #FF6A40',
              color: '#ffffff',
              background: '#FF6A40'
            }
          }
        ]),
        width: '460px'
      }
    ],
    formParams: {
      uid: '',
      orgUid: (params) => {
        return params.orgValue
      },
      code: '',
      name: '',
      factoryType: '',
      adminName: '',
      adminPhone: '',
      adminPersonUid: '',
      startStake: '',
      endStake: '',
      mark: '',
      lnglat: ''
    },
    formRules: {
      code: [
        {
          required: true,
          message: '请输入场站工区编码',
          trigger: 'blur'
        }
      ],
      name: [
        {
          required: true,
          message: '请输入场站工区名称',
          trigger: 'blur'
        }
      ],
      factoryType: [
        {
          required: true,
          message: '请选择场站工区类型',
          trigger: 'change'
        }
      ],
      adminPhone: [
        {
          pattern: /^$|^1(3|4|5|6|7|8|9)\d{9}$/,
          message: '手机号码输入不合法',
          trigger: 'blur'
        }
      ],
      startStake: [
        {
          pattern: /^(\d+(\.\d{1,3})?)?$/,
          message: '请输入数字，如有小数则小数点后最多3位',
          trigger: 'blur'
        }
      ],
      endStake: [
        {
          pattern: /^(\d+(\.\d{1,3})?)?$/,
          message: '请输入数字，如有小数则小数点后最多3位',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '场站工区信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'code',
          label: '场站工区编码',
          type: 'input',
          placeholder: '请输入场站工区编码'
        },
        {
          key: 'name',
          label: '场站工区名称',
          type: 'input',
          placeholder: '请输入场站工区名称'
        },
        {
          key: 'factoryType',
          label: '场站工区类型',
          type: 'select',
          placeholder: '请选择场站工区类型',
          options: [
            { label: '项目驻地', value: '项目驻地' },
            { label: '混拌站', value: '混拌站' },
            { label: '稳拌站', value: '稳拌站' },
            { label: '沥拌站', value: '沥拌站' },
            { label: '预制厂', value: '预制厂' },
            { label: '钢筋加工厂', value: '钢筋加工厂' },
            { label: '作业工区', value: '作业工区' }
          ]
        },
        {
          key: 'admin',
          label: '负责人姓名',
          type: 'select',
          placeholder: '请选择或输入负责人',
          options: (params) => {
            var options = params.state.contractor.managePersonNames || []
            if (
              params.pageStatus === 'edit' &&
              params.formValues &&
              params.formValues.admin &&
              !options.some(
                (item) => item.value === params.formValues.admin.value
              )
            ) {
              options.push(params.formValues.admin)
            }
            return options
          },
          filterable: true,
          create: true,
          valueKey: 'value',
          bindKeys: ['label', 'phoneNumber', 'value'],
          formKeys: ['adminName', 'adminPhone', 'adminPersonUid']
        },
        {
          key: 'adminPhone',
          label: '负责人电话',
          type: 'input',
          placeholder: '请输入负责人电话'
        },
        {
          key: 'startStake',
          label: '起点桩号',
          type: 'input',
          placeholder: '请输入起点桩号数值，例8000表示K8+000'
        },
        {
          key: 'endStake',
          label: '终点桩号',
          type: 'input',
          placeholder: '请输入终点桩号数值，例8000表示K8+000'
        },
        {
          key: 'lnglat',
          label: '经纬度坐标',
          type: 'input',
          placeholder: '请在地图中点选',
          inputButton: '地图点选',
          buttonIcon: 'el-icon-location-outline input_button_i'
        },
        {
          key: 'mark',
          label: '地理位置',
          type: 'input',
          inputType: 'textarea',
          placeholder: '地图点选后自动获取，也可手动输入',
          autosize: { minRows: 2, maxRows: 6 }
        }
      ]
    },
    factoryBindAdmin: {
      name: 'factoryBindAdmin',
      title: '关联管理人员',
      editFun: 'organization/saveFactoryAdminBind',
      getParentFun: 'organization/getOrgFactory',
      formParams: {
        uid: '',
        boundKeys: [],
        originalBoundKeys: []
      },
      formData: [
        {
          key: 'bindTip',
          type: 'tag',
          tag: '仅可关联本机构已进场且在场的管理人员',
          span: 24
        },
        {
          key: 'boundKeys',
          label: '管理人员',
          type: 'transfer',
          checkByValue: true,
          titles: ['未关联', '已关联'],
          filterable: true,
          filterPlaceholder: '姓名',
          options: (params) => params.state.organization.factoryBindOptions,
          span: 24
        }
      ]
    },
    factoryBindCar: {
      name: 'factoryBindCar',
      title: '关联机械设备',
      editFun: 'organization/saveFactoryCarBind',
      getParentFun: 'organization/getOrgFactory',
      formParams: {
        uid: '',
        boundKeys: [],
        originalBoundKeys: []
      },
      formData: [
        {
          key: 'bindTip',
          type: 'tag',
          tag: '仅可关联本机构已进场且在场的机械设备',
          span: 24
        },
        {
          key: 'boundKeys',
          label: '机械设备',
          type: 'transfer',
          checkByValue: true,
          titles: ['未关联', '已关联'],
          filterable: true,
          filterPlaceholder: '设备编号/名称/型号',
          options: (params) => params.state.organization.factoryBindOptions,
          span: 24
        }
      ]
    },
    factoryBindLabor: {
      name: 'factoryBindLabor',
      title: '关联劳务公司',
      editFun: 'organization/saveFactoryLaborBind',
      getParentFun: 'organization/getOrgFactory',
      formParams: {
        uid: '',
        boundKeys: [],
        originalBoundKeys: []
      },
      formData: [
        {
          key: 'bindTip',
          type: 'tag',
          tag: '仅可关联本机构下属已进场且在场的劳务公司',
          span: 24
        },
        {
          key: 'boundKeys',
          label: '劳务公司',
          type: 'transfer',
          checkByValue: true,
          titles: ['未关联', '已关联'],
          filterable: true,
          filterPlaceholder: '劳务公司',
          options: (params) => params.state.organization.factoryBindOptions,
          span: 24
        }
      ]
    },
    factoryAdmins: {
      name: 'factoryAdmins',
      title: '已关联管理人员',
      rowData: (params) => params.state.organization.factoryAdminList,
      columns: [
        { prop: 'personName', label: '姓名' },
        { prop: 'jobTitle', label: '岗位职务' },
        { prop: 'personPhone', label: '手机号' },
        { prop: 'entryDate', label: '进场日期' },
        {
          prop: 'noteInfo',
          label: '在场状态',
          width: '100px',
          tag: [
            { label: '在场', type: 'success' },
            { label: '退场', type: 'danger' }
          ]
        }
      ]
    },
    factoryCars: {
      name: 'factoryCars',
      title: '已关联机械设备',
      rowData: (params) => params.state.organization.factoryCarList,
      columns: [
        { prop: 'carCode', label: '设备编号' },
        { prop: 'carName', label: '设备名称' },
        { prop: 'carModel', label: '设备型号' },
        { prop: 'carUsage', label: '设备用途' },
        { prop: 'entryDate', label: '进场日期' },
        {
          prop: 'noteInfo',
          label: '在场状态',
          width: '100px',
          tag: [
            { label: '在场', type: 'success' },
            { label: '退场', type: 'danger' }
          ]
        }
      ]
    },
    factoryLabors: {
      name: 'factoryLabors',
      title: '已关联劳务公司',
      rowData: (params) => params.state.organization.factoryLaborList,
      columns: [
        { prop: 'laborOrgName', label: '劳务公司名称' },
        { prop: 'leaderName', label: '现场负责人' },
        { prop: 'leaderPhone', label: '现场负责人手机号', width: '180px' },
        { prop: 'entryDate', label: '进场日期' },
        {
          prop: 'noteInfo',
          label: '在场状态',
          width: '100px',
          tag: [
            { label: '在场', type: 'success' },
            { label: '退场', type: 'danger' }
          ]
        }
      ]
    }
  }
}

export default organization
